import { CONFIGCAT_FLAGS } from '@/types/ConfigCatFlags'

import * as configcat from 'configcat-js'

export class ConfigCatHelper {
	static async getFeatureFlagValue(featureFlag: CONFIGCAT_FLAGS, defaultValue: boolean = false, user?: configcat.User) {
		let configCatClient = configcat.getClient(import.meta.env.VUE_APP_CONFIG_CAT_KEY, configcat.PollingMode.LazyLoad, {})
		let result = await configCatClient.getValueAsync(featureFlag, defaultValue, user)
		return result
	}

	private static createUserObjectByEmail(email?: string) {
		if (!email) return undefined
		const identifier = email
		return new configcat.User(identifier, email)
	}

	private static createUserObjectByCustom(customKey: string, customValue: string) {
		if (!customKey || !customValue) return undefined
		const identifier = customValue
		return new configcat.User(identifier, undefined, undefined, { [customKey]: customValue })
	}

	static async getIsolveFieldEndOfInspection() {
		return await this.getFeatureFlagValue(CONFIGCAT_FLAGS.FIELD_END_OF_INSPECTION)
	}

	static async getIsolveDisableDecisionTabForItau() {
		return await this.getFeatureFlagValue(CONFIGCAT_FLAGS.DISABLE_DECISION_TAB_FOR_ITAU)
	}

	static async getButtonCreatePreAnalysis() {
		return await this.getFeatureFlagValue(CONFIGCAT_FLAGS.BUTTON_CREATE_PRE_ANALYSIS)
	}

	static async getIsPhoneUpdateModalDisabled(email?: string) {
		const userObject = this.createUserObjectByEmail(email)
		return await this.getFeatureFlagValue(CONFIGCAT_FLAGS.DISABLE_PHONE_UPDATE_MODAL, true, userObject)
	}

	static async getIsNovosCompradoresInternalCorbanPriorities() {
		return await this.getFeatureFlagValue(CONFIGCAT_FLAGS.NOVOS_COMPRADORES_INTERNAL_CORBAN_PRIORITIES)
	}

	static async getIsNovosCompradoresSortByBackendPriority() {
		return await this.getFeatureFlagValue(CONFIGCAT_FLAGS.NOVOS_COMPRADORES_SORT_BY_BACKEND_PRIORITY)
	}

	static async getIsNewAuthFlowEnabled(userType: string) {
		const userObject = this.createUserObjectByCustom('userType', userType)
		return await this.getFeatureFlagValue(CONFIGCAT_FLAGS.ENABLE_NEW_AUTH_FLOW, false, userObject)
	}

	static async getIsOpaEnabled() {
		return await this.getFeatureFlagValue(CONFIGCAT_FLAGS.IS_OPA_ENABLED)
	}

	static async getIsPaginatedProposalObservationsEnabled() {
		return await this.getFeatureFlagValue(CONFIGCAT_FLAGS.ENABLE_PAGINATED_PROPOSAL_OBSERVATIONS)
	}

	static async getIsHideArchiveButtonForMmsSourceEnabled() {
		return await this.getFeatureFlagValue(CONFIGCAT_FLAGS.HIDE_ARCHIVE_BUTTON_FOR_MMS_SOURCE)
	}

	static async getIsMagicLinkEditionEnabled() {
		return await this.getFeatureFlagValue(CONFIGCAT_FLAGS.MAGIC_LINK_EDITION)
	}
}
